import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { catchError, map, of } from 'rxjs';

import { UserService, canUploadAllFolders } from '../services/user.service';

// Sends anyone without the upload permission (or whose /api/me fails) from
// /upload back to their files. UX only — the API refuses their uploads anyway.
export const uploadAccessGuard: CanActivateFn = () => {
  const userService = inject(UserService);
  const router = inject(Router);
  return userService.currentUser().pipe(
    map((user) => (canUploadAllFolders(user) ? true : router.createUrlTree(['/']))),
    catchError(() => of(router.createUrlTree(['/']))),
  );
};
